import type { BolsterAction } from "../types/actions";
import type { ValidationResult } from "../types/common";
import type { WarchestState } from "../types/game-state";
import { isValidHex } from "../utils/hex-utils";
import { hasCoin } from "../utils/zone-utils";

export function validateBolster(
  state: WarchestState,
  action: BolsterAction,
): ValidationResult {
  if (state.phase !== "USE_COINS") {
    return { valid: false, error: "Not in USE_COINS phase" };
  }
  if (action.player !== state.activePlayer) {
    return { valid: false, error: "Not your turn" };
  }
  const zones = state.playerZones[action.player];
  if (!hasCoin(zones, action.coinType, "hand")) {
    return { valid: false, error: "Coin not in hand" };
  }
  if (action.coinType === "ROYAL") {
    return { valid: false, error: "Royal Coin cannot bolster" };
  }
  const boardDef = state.config.boards[state.boardId];
  if (!boardDef || !isValidHex(boardDef, action.targetHex)) {
    return { valid: false, error: "Invalid target hex" };
  }
  const cell = state.board[action.targetHex];
  if (!cell) {
    return { valid: false, error: "No unit at target hex" };
  }
  if (cell.owner !== action.player) {
    return { valid: false, error: "Unit at target hex is not yours" };
  }
  if (cell.unitType !== action.coinType) {
    return {
      valid: false,
      error: "Coin type does not match deployed unit type",
    };
  }
  if (cell.stackSize >= 3) {
    return { valid: false, error: "Stack is already at maximum size (3)" };
  }
  return { valid: true };
}
